import { Button, Grid } from '@mui/material';
import React, { ChangeEvent, useCallback, useState } from 'react';
import { TextInput } from 'src/UIKit/components/TextInput';

interface LinkTabContentProps {
  linkToFileNote?: string;
  value: File | string | null | undefined;
  onSubmit: (value: string) => void;
}

const withHttps = (url: string): string => {
  return /^(http(s?)):\/\//i.test(url) ? url : `https://${url}`;
};

export const LinkTabContent: React.FC<LinkTabContentProps> = ({
  linkToFileNote,
  value: externalValue,
  onSubmit,
}) => {
  const [value, setValue] = useState(typeof externalValue === 'string' ? externalValue : '');

  const change = useCallback((_: ChangeEvent<HTMLInputElement>, value: string) => {
    setValue(value);
  }, []);

  const submit = useCallback(() => {
    onSubmit(withHttps(value));
  }, [value, onSubmit]);

  return (
    <Grid container sx={{ flexDirection: 'column', alignItems: 'flex-end', gap: '20px' }}>
      <Grid item sx={{ width: 'inherit' }}>
        <TextInput
          value={value}
          onChange={change}
          endIcon="File URL"
          helperText={linkToFileNote}
          margin="none"
        />
      </Grid>

      <Grid item>
        <Button onClick={submit} disabled={!value} variant="contained">
          Attach
        </Button>
      </Grid>
    </Grid>
  );
}; 